// extracted by mini-css-extract-plugin
module.exports = {"shadow":"shadow___251J4","box":"box___1VAo3","box1":"box1___2X0OQ","box2":"box2___W9LhO","container":"container___2zkVm","divider":"divider___PQbIW","comments":"comments___3ZzsE"};